export type PatientRosterSortBy =
  | 'clinic'
  | 'patient_first'
  | 'patient_last'
  | 'mrn'
  | 'triage_code'
  | 'disaster_code'
  | 'pdx'
  | 'sdx'
  | 'episode_start_date'
  | 'episode_end_date'
  | 'oasis_date';

/**
 * Array of all PatientRosterSortBy values.
 */
export const PATIENTROSTERSORTBY_VALUES: readonly PatientRosterSortBy[] = [
  'clinic',
  'patient_first',
  'patient_last',
  'mrn',
  'triage_code',
  'disaster_code',
  'pdx',
  'sdx',
  'episode_start_date',
  'episode_end_date',
  'oasis_date',
] as const;
